interface FunFact {
	[key:string]: {}
}

const countries: FunFact = {
	CZ: {},
	SK: {},
	PL: {},
	DE: {},
	AT: {},
	HU: {},
	RO: {},
	UA: {},
	PT: {},
	IT: {},
	IE: {},
	LV: {},
	LT: {},
	EE: {},
	GR: {},
	ES: {},
	FR: {},
	FI: {},
	RU: {},
}

export default countries
